import { swipeTile } from "./removeItemAnimations";
import store from "../vue/components/store";
import { globalUtilInit } from "../utilities/globalUtilities";
import { initTooltip } from "../components/toolTip";
import ProductQtyMap from "../utilities/ProductQtyMap";
import { stickyHeaderInit } from "../components/header";
import { updateMinicartInfo, updateProductQtyMap, triggerCartUpdate, resetProductNote, getGTMData } from "../components/cartUtil";
import SimpleBar from "simplebar";
import { CART, MINICART_QUANTITY_LIMIT, UNDO_DELAY_TIME } from "../utilities/constants";
import { mobileMenuButtonToggle } from "./menuUtils";
import { initCssLoader } from "../components/lazyLoadTemplate";
import { loadingDots } from "./pageLoading";
import { kvlMakeProductsArray } from "../kevel/audience";
import { pushEventData, pushCleanEcommerceObject } from "../dataLayer/utils";

var cart = require("../cart/cart");
var urlUtils = require("../search/urlUtils");
var minicartVue = require("./minicartVue");
var confirmationToast = require("../components/confirmationToast");
var updateMiniCart = true;
var productRemovalActions = {};
const scrollLock = require("../utilities/scrollLock");
const mqueryRespond = window.mqRespond;
const debounce = require("lodash/debounce");

let $cache = {};

const initCache = () => {
    $cache = {
        document: $(document),
        body: $("body"),
        htmlBody: $("body,html"),
        window: $(window),
        minicart: $(".minicart"),
        miniCartModalBg: $(".js-modal-bg-minicart"),
        minicartPopover: $(".minicart .ct-popover"),
        bgModal: $(".modal-background"),
        isOpen: $(".minicart .ct-popover").hasClass("show"),
        miniCartGrandTotal: $(".minicart-grandtotal"),
        pageTypeValue: $("[data-page-type]").data("page-type"),
        cartCleanConfirmationModal: $("#confirm-clean-cart-modal"),
        mainMenu: $(".main-menu")
    };
};

/**
 * @function
 * @description
 * @param {Element} $container - Product tile/PDP container
 * @param {Object} item - Quantity item
 */
function updateQuantity($container, item) {
    $container.find(".quantity-update").attr("data-uuid", item.UUID).attr("data-previous-val", item.quantity);
}

/**
 * Updates the MiniCart Totals
 *
 * @param {Object} product - product to have the total price updated
 */
function updateMiniCartTotals(cartTotal, product) {
    if (product) {
        var $productPrice = $(`.totalPrice.${product.id}`);

        // Update the Product Total Price
        if ($productPrice.length) {
            $productPrice.text(product.priceTotal.price);
        }
    }

    // Update the MiniCart Total Price
    $(".sub-total").text(cartTotal);
}

/**
 * Handle the errors
 * @param {Object} err - Error object
 */
function handleError(err) {
    if (err.responseJSON.redirectUrl) {
        window.location.href = err.responseJSON.redirectUrl;
    } else {
        var errorHtml = "<div class=\"alert alert-danger alert-dismissible valid-cart-error " +
            "fade show\" role=\"alert\">" +
            "<button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\">" +
            "<span aria-hidden=\"true\">&times;</span>" +
            "</button>" + err.responseJSON.errorMessage + "</div>";

        $(".cart-error").append(errorHtml);

        //GTM logic - Start
        document.dispatchEvent(new CustomEvent("dataLayer.messagesEvents", {
            detail: {
                "success": false,
                "messageContent": err.responseJSON.errorMessage
            }
        }));
        //GTM logic - End
    }
}

const minicart = {
    show: () => {
        const $userNavItem = $(".user.nav-item.d-block");
        $cache.htmlBody.addClass("f-vh-height");
        initCache();
        if (mqueryRespond.status.desktop || mqueryRespond.status.desktopLarge) {
            $cache.miniCartModalBg.show();
        } else {
            const $stickyBanner = $cache.document.find(".sticky-banner:not(.d-none)");
            const existingStickyHeight = $stickyBanner.length ? parseFloat($stickyBanner.outerHeight(true)) : 0;

            if ($cache.window.scrollTop() > 0) {
                const $stickyNavWrapper = $(".nav-wrapper >.sticky-element");
                $stickyNavWrapper.addClass("is-sticky");
                $stickyNavWrapper.css("top", parseInt(existingStickyHeight, 10));
            }
        }

        if (!$cache.mainMenu.hasClass("d-none")) { mobileMenuButtonToggle(); }

        $cache.body.addClass("modal-open");
        $cache.body.addClass("minicart-opened");
        scrollLock.enable();
        $userNavItem.removeClass("is-logged-header-menu");
        $cache.minicartPopover.addClass("show");
        $cache.minicart.addClass("is-open");

        //Remove Tooltip
        const toolTip = $(".tooltip.fade.show");
        toolTip.removeClass("show");

        //Remove Snackbar
        const $snackbar = $(".couponToast");
        $snackbar.css("display", "none");
    },
    hide: () => {
        $cache.htmlBody.removeClass("f-vh-height");
        $cache.body.removeClass("modal-open");
        $cache.body.removeClass("minicart-opened");
        scrollLock.disable();
        $cache.minicartPopover.removeClass("show");
        $cache.minicart.removeClass("is-open");
        $cache.miniCartModalBg.hide();
        $cache.bgModal.hide();
    },
    setPosition: () => {
        let currentHeaderHeight = $("header").outerHeight(true);
        const headerElementsHeight = $(".sticky-container").outerHeight(true) + $(".header-wrapper").outerHeight(true);

        if (!mqueryRespond.status.mobile && !mqueryRespond.status.tablet) {
            $cache.minicartPopover.removeAttr("style");
            return;
        }

        if ($(window).scrollTop() == 0) {
            $cache.minicartPopover.css({
                "top": Math.floor(currentHeaderHeight)+"px"
            });
        } else {
            $cache.minicartPopover.css({
                "top": Math.floor(headerElementsHeight)+"px"
            });
        }
    },

    setPopoverHeight: () => {
        const isDesktop = mqueryRespond.status.desktop || mqueryRespond.status.desktopLarge;
        const windowHeight = window.innerHeight;
        const $minicartPopover = $(".minicart .ct-popover");

        if (!isDesktop) {
            return;
        }

        $minicartPopover.css("height", windowHeight);
    },

    setInnerHeight: () => {
        const isDesktop = mqueryRespond.status.desktop || mqueryRespond.status.desktopLarge;
        const currentHeaderHeight = isDesktop ? 0 : $("header").outerHeight(true);
        const minicartHeaderHeight = $(".minicart-header").outerHeight(true);
        const windowHeight = window.innerHeight;
        const $emptyMinicart = $(".minicart-products-empty");
        let totalHeight = 0;

        minicart.setPopoverHeight();

        if ($emptyMinicart.length) {
            totalHeight = windowHeight - (currentHeaderHeight + minicartHeaderHeight);
            $emptyMinicart.css("height", totalHeight + "px");
        } else {
            const $minicartFooter = $(".minicart-footer");
            const minicartFooterHeight = $minicartFooter.outerHeight(true);

            totalHeight = windowHeight - (currentHeaderHeight + minicartHeaderHeight + minicartFooterHeight);
            $(".minicart-products-container").css("height", totalHeight + "px");
        }
    },

    clearEntregaZero: () => {
        const $minicartEntregaZero = $(".minicart-area-entrega");
        const $minicartProductsList = $(".minicart-products-container");

        if (window.entregaZeroTimeout) {
            clearTimeout(window.entregaZeroTimeout);
            $minicartEntregaZero.removeClass("minicart-area-entrega--hidden");
            $minicartProductsList.removeClass("no-entrega-zero");
        }
    },

    addEntregaZero: () => {
        const $minicartEntregaZero = $(".minicart-area-entrega");
        const $minicartProductsList = $(".minicart-products-container");
        const delayTime = $minicartEntregaZero.find(".minicart-area-inner").data("entrega-zero-delay");
        const $minimumOrderValue = $(".minicart-minimumOrderValue");

        if ($minimumOrderValue.length && $minimumOrderValue.is(":not(':hidden')")) {
            $minicartEntregaZero.addClass("minicart-area-entrega--with-minimumOrderValue");
        } else {
            $minicartEntregaZero.removeClass("minicart-area-entrega--with-minimumOrderValue");
        }

        window.entregaZeroTimeout = setTimeout(() => {
            $minicartEntregaZero.addClass("minicart-area-entrega--hidden");
            $minicartProductsList.addClass("no-entrega-zero");
            minicart.setInnerHeight();
        }, delayTime);
    },

    addThresholdCampaign: () => {
        if ($(".threshold_campaign").length && $(".threshold_campaign").is(":not(':hidden')")) {
            $(".minicart-area-entrega").addClass("minicart-area-entrega--with-thresholdCampaign");
        } else {
            $(".minicart-area-entrega").removeClass("minicart-area-entrega--with-thresholdCampaign");
        }
    },

    resize: () => {
        let lastWindowWidth = $(window).width(),
            lastWindowHeight = $(window).height();

        $(window).resize(function () {
            let newWindowWidth = $(window).width(),
                newWindowHeight = $(window).height();

            if (newWindowHeight > lastWindowHeight && newWindowWidth == lastWindowWidth) {
                $(".minicart-products-container").removeClass("minicart-products-container--scrolled");
            }

            lastWindowWidth = newWindowWidth;
            lastWindowHeight = newWindowHeight;
        });
    }
};

const initializeEvents = () => {
    var simpleBar;
    var events = "orientationchange";

    const ua = navigator.userAgent.toLowerCase();
    const isAndroid = ua.indexOf("android") > -1;
    if (!isAndroid) {
        events = events + " resize";
    }

    $(window).on(events, debounce(() => {
        minicart.setInnerHeight();
        minicart.setPosition();
    }, 125));

    $cache.document.on("click", ".minicart-link", ev => {
        ev.preventDefault();
    }).on("click", ".minicart", function (ev) {
        $cache.isOpen = $cache.minicartPopover.hasClass("show");

        const canClose =
            $(ev.target).parents(".ct-popover").length == 0 ||
            $(ev.target).hasClass("minicart-close") ||
            $(ev.target).parents(".minicart-close").length > 0;

        if (!$cache.isOpen) {
            if ($(".minicart .ct-popover.show").length === 0) {
                if (!updateMiniCart) {
                    minicart.show();
                    minicart.setPosition();
                    minicart.clearEntregaZero();
                    minicart.addEntregaZero();
                    minicart.addThresholdCampaign();
                    minicart.setPopoverHeight();

                    // reinit simplebar
                    if (simpleBar !== undefined) {
                        simpleBar.unMount();
                    }
                    simpleBar = new SimpleBar(document.getElementById("minicart-products-container"));
                    return;
                }

                var url = $(".minicart").data("action-url");

                minicart.show();
                confirmationToast.cleanConfirmationToast();
                $cache.minicartPopover.spinner().start();
                $.get(url, function (data) {
                    if ($cache.miniCartGrandTotal.length > 0 && data.basket.totals.totalPriceProductsOnly) {
                        const priceText = data.basket.totals.hideZeroPrice === true ? "" : data.basket.totals.totalPriceProductsOnly;
                        $cache.miniCartGrandTotal.text(priceText);
                    }
                    if ($(".minicart-vue").length > 0) {
                        minicartVue.initVueMinicart(".minicart-vue", data);
                        initTooltip(".ct-popover");
                    } else {
                        store.commit("setBasketInfo", data.basket);
                    }

                    if ($cache.minicartPopover.find(".minicart-products-empty").length == 0) {
                        initTooltip();
                    }

                    if (mqueryRespond.status.mobile) {
                        swipeTile();
                    }
                    updateMiniCart = false;
                    minicart.clearEntregaZero();
                    minicart.addEntregaZero();
                    minicart.addThresholdCampaign();
                    minicart.setInnerHeight();
                    if (mqueryRespond.status.mobile) {
                        minicart.resize();
                    }

                    globalUtilInit();
                    $.spinner().stop();
                });
                minicart.setPosition();

                // reinit simplebar
                if (!document.querySelector(".minicart-products-container")) { return; }
                if (simpleBar !== undefined) {
                    simpleBar.unMount();
                }
                simpleBar = new SimpleBar(document.getElementById("minicart-products-container"));
            }
        } else if (canClose) {
            minicart.setPosition();
            minicart.hide();
            minicart.clearEntregaZero();
            stickyHeaderInit();
        }
    });

    if ($(".product-tile").length > 0 && parseInt($(".minicart .minicart-quantity").text(), 10) !== 0) {
        $cache.body.trigger("product:syncTileData", ProductQtyMap);
    }

    let isRemoveTriggered = false;
    // Remove Product From MiniCart
    $cache.document.on("click", ".minicart-remove-product", function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (isRemoveTriggered) { return; }

        isRemoveTriggered = true;

        var productID = $(this).data("pid");
        var $productRow = $(`.minicart-product-row[data-pid="${productID}"]`);
        var $productRemoved = $(`.ct-product-removed[data-pid="${productID}"]`);
        var undoDelayTime = $(this).data("undo-delay") || UNDO_DELAY_TIME;
        var url = $(this).data("action");
        var uuid = $(this).data("uuid");
        var list = $(this).closest(".gtm-list")?.data("gtm-list");
        var $productLine = $productRow.closest(".minicart-product-line");
        var {gtmIndex, gtmList} = getGTMData($productLine, list);
        var urlParams = {
            pid: productID,
            uuid: uuid,
            gtmIndex: gtmIndex,
            gtmList: gtmList
        };

        $cache.isOpen = $cache.minicartPopover.hasClass("show");

        url = urlUtils.appendToUrl(url, urlParams);

        $productRow.addClass("d-none");
        $productRemoved.removeClass("d-none");

        productRemovalActions[productID] = setTimeout(() => {
            $.spinner().start();

            $.ajax({
                url: url,
                type: "get",
                dataType: "json",
                success: function (data) {
                    confirmationToast.cleanConfirmationToast();
                    confirmationToast.showConfirmationToast($productRow.find(".decrease-quantity-btn"), null, 1, true);

                    $productRow.remove();
                    $productRemoved.remove();

                    const $tile = $(`.product-tile.pid-${productID}`);
                    const $brandID = $tile.attr("data-brandID");
                    const $pdpQtyContainer = $(`.ct-tile-quantity[data-pid="${productID}"]`);

                    // Remove Qty Input from Tile
                    if ($tile.length) {
                        $tile.closest(".product").removeClass("highlighted-in-red " + $brandID + "-color-highlighted");
                        $tile.attr("data-product-added-to-cart", "");
                        $tile.find(".add-to-cart").removeClass("hide");
                        $tile.find(".ct-tile-quantity").addClass("d-none");
                        $tile.find(".quantity-update").attr("data-previous-val", 0);
                    }

                    // Remove Qty Input from PDP
                    if ($pdpQtyContainer.length > 0) {
                        $pdpQtyContainer.siblings(".add-to-cart").removeClass("hide");
                        $(".add-to-cart.js-add-to-cart.js-add-to-cart-button").removeClass("d-none");
                        $pdpQtyContainer.addClass("d-none").siblings(".js-notes-container").find(".add-note, .add-note-section").addClass("d-none");
                        $pdpQtyContainer.find(".quantity-update").attr("data-previous-val", 0);
                    }

                    if (data.basket.numItems === 0) {
                        $(".minicart-wrapper").addClass("empty-cart");
                        $cache.body.trigger("cart:update");
                    } else {
                        updateMiniCartTotals(data.basket.totals.subTotal);
                        $(".minicart").trigger("count:update", data.basket);
                        updateMinicartInfo(data);
                    }

                    updateProductQtyMap(data.basket);
                    store.commit("setBasketInfo", data.basket);
                    triggerCartUpdate();

                    // Reset add product note input state and note icon
                    const isProductDetailPDP = $(`.product-detail[data-pid="${productID}"]`).length;
                    const isMobile = window.mqRespond.status.mobile;

                    if (isProductDetailPDP) {
                        resetProductNote();

                        if (isMobile) {
                            const $noteAddIconWrapper = $(".js-notes-container").find(".add-note");

                            if ($noteAddIconWrapper.length && $noteAddIconWrapper.hasClass("d-none")) {
                                $noteAddIconWrapper.removeClass("d-none");
                            }
                        }
                    }

                    //GTM remove from cart event - start
                    document.dispatchEvent(new CustomEvent("dataLayer.removeFromCart", {
                        detail: {
                            "dataLayerObject": data?.dataLayerObject
                        }
                    }));

                    if (data?.minicartDataLayerObject) {
                        $(".minicart").trigger("minicart:updateDatalayer", data.minicartDataLayerObject);
                    }
                    //GTM remove from cart event - end

                    $.spinner().stop();
                },
                error: function (err) {
                    handleError(err);
                    $.spinner().stop();
                }
            });
        }, undoDelayTime);

        setTimeout(() => {
            isRemoveTriggered = false;
        }, 0);
    }).on("click", ".undo-remove", function (e) { // Undo Product Removal
        e.preventDefault();


        var productID = $(this).data("pid");
        var $productRow = $(`.minicart-product-row[data-pid="${productID}"]`);
        var $productRemoved = $(`.ct-product-removed[data-pid="${productID}"]`);

        clearTimeout(productRemovalActions[productID]);

        if ($productRow.length && $productRemoved.length) {
            $productRow.removeClass("d-none");
            $productRemoved.addClass("d-none");
        }

        triggerCartUpdate();
    });

    $cache.body.on("product:syncTileData", function (event, basketData) {
        if (basketData && basketData.items && basketData.items.length > 0) {
            basketData.items.forEach(item => {
                let $tile = $(".product-tile.pid-" + item.id);
                const $brandID = $tile.attr("data-brandID");
                let productsAddedToCart = $tile.attr("data-product-added-to-cart");
                productsAddedToCart = productsAddedToCart ? [productsAddedToCart, item.id].join(",") : item.id;
                $tile.attr("data-product-added-to-cart", productsAddedToCart);
                var $pdpQtyContainer = $(`.ct-tile-quantity[data-pid="${item.id}"]`);

                $tile.each(function () {
                    var $this = $(this);
                    if (!$this.closest(".slick-slide").hasClass("slick-cloned")) {
                        if ($this.length > 0) {
                            $this.closest(".product").addClass("highlighted-in-red " + $brandID + "-color-highlighted");
                            $this.closest(".product").attr("data-pid", item.id);
                            updateQuantity($this, item);
                        }
                    }
                });

                if ($pdpQtyContainer.length > 0) {
                    updateQuantity($pdpQtyContainer, item);
                }
            });

            updateMinicartInfo(basketData);
        }
    }).on("touchstart click", e => {
        const shouldHideMinicart = $(".minicart").has(e.target).length <= 0 &&
            $cache.minicartPopover.hasClass("show") &&
            !e.target.classList.contains("spinner") &&
            e.target.closest(".modal") && e.target.closest(".modal").length === 0;

        shouldHideMinicart && minicart.hide();
    }).on("change", ".minicart .quantity", function () {
        if ($(this).parents(".bonus-product-line-item").length && $(".cart-page").length) {
            location.reload();
        }
    }).on("product:afterAddToCart", () => {
        updateMiniCart = true;
    }).on("cart:update", () => {
        updateMiniCart = true;

        if (["", "0"].indexOf($(".minicart-quantity").first().text()) != -1) {
            $cache.miniCartGrandTotal.text("");
        }
    });

    $(".minicart").on("count:update", function (event, count) {
        if (count) {
            var basketTotal = count.cart && count.cart.totals && count.cart.totals.totalPriceProductsOnly ? count.cart.totals.totalPriceProductsOnly : "";
            var minicartTotal = basketTotal;

            if (basketTotal == "") {
                minicartTotal = count.totals != "" && count.totals?.totalPriceProductsOnly != "" ? count.totals?.totalPriceProductsOnly : "";
            }

            if (count.totals && count.totals.hideZeroPrice && count.totals.hideZeroPrice === true) {
                minicartTotal = "";
            }

            const $minicartQty = $(".minicart .minicart-quantity");

            if ($minicartQty.length > 0) {
                const counter = (count.cart) ? count?.cart?.items?.length : count?.items?.length;
                const quantityTotal = (count.cart) ? count.cart.quantityTotal : count.quantityTotal;

                $minicartQty.text(quantityTotal || counter);
                $minicartQty.toggleClass("minicart-quantity--expanded", quantityTotal >= MINICART_QUANTITY_LIMIT || counter >= MINICART_QUANTITY_LIMIT);
                $(".minicart .minicart-link").attr({
                    "aria-label": count?.minicartCountOfItems || count?.resources?.minicartCountOfItems
                });
                if (counter > 0) {
                    $(".minicart-wrapper").removeClass("empty-cart");
                }
            } else {
                // Backup minicart vue component if already initialized
                let minicartVueBkp;

                if ($(".minicart-vue").length === 0) {
                    minicartVueBkp = $(".ct-popover");
                }

                $(".minicart").load($(this).data("load-minicart"), () => {
                    $cache.document.on("click", ".minicart-link", ev => {
                        ev.preventDefault();
                    });

                    if (minicartVueBkp) {
                        $(".ct-popover").replaceWith(minicartVueBkp);
                    }
                });
            }

            //cached value causes the issue with minicart, so non-cached is used
            if ($(".minicart-grandtotal").length) {
                $(".minicart-grandtotal").text(minicartTotal);
            }
        }
    }).on("minicart:update", (event, response) => {
        var cartTotal = ("cartTotal" in response) ? response.cartTotal : 0;
        var product = ("product" in response) ? response.product : null;
        updateMiniCartTotals(cartTotal, product);
    }).on("minicart:updateDatalayer", (event, dataLayer) => {
        var input = $("input[name='minicartDataLayer']");

        if (input) {
            input.val(JSON.stringify(dataLayer));
        }
    });

    if ($(".product-tile").length > 0 && parseInt($(".minicart .minicart-quantity").text(), 10) !== 0) {
        $cache.body.trigger("product:syncTileData", ProductQtyMap);
    }

    $cache.document.on("click", ".minicart-clean-button", function () {
        const list = $(this).closest(".gtm-list")?.data("gtm-list");
        $cache.cartCleanConfirmationModal.data("list", list).modal("show");
    });

    loadingDots(".minicart-add-button");

    $cache.document.on("click", ".confirm-confirm-clean-cart-select", function () {
        const $this = $(this);
        const cleanCartUrl = $this.data("clean-cart-url");

        $.spinner().start();
        $($this, ".decline-confirm-clean-cart-select").prop("disabled");

        const list = $cache.cartCleanConfirmationModal.data("list");
        const urlParams = {
            gtmList: $cache.cartCleanConfirmationModal.data("list")
        };
        const url = list !== undefined ? urlUtils.appendToUrl(cleanCartUrl, urlParams) : cleanCartUrl;
        
        $.ajax({
            url: url,
            method: "POST",
            success: function (data) {
                if (data.success && data.dataLayerObject) {
                    document.dispatchEvent(new CustomEvent("dataLayer.removeFromCart", { detail: { "dataLayerObject": data.dataLayerObject }}));
                }
            },
            complete: function () {
                window.location.reload();
            }
        });
    });

    $cache.document.on("click", ".minicart-add-button", function (e) {
        // Send "begin_checkout" event when buy button is clicked, before going to recommendations page
        e.preventDefault();

        let minicartDatalayerObj = $("input[name='minicartDataLayer']").val();

        if (minicartDatalayerObj) {
            minicartDatalayerObj = JSON.parse(minicartDatalayerObj);
            minicartDatalayerObj.event = "begin_checkout";
            pushCleanEcommerceObject();
            pushEventData(minicartDatalayerObj);
        }

        let kvlProductArray = [];
        kvlProductArray = kvlMakeProductsArray(minicartDatalayerObj.ecommerce.items, minicartDatalayerObj);

        if (kvlProductArray.length > 0) {
            window.sessionStorage.setItem("kvlProductArray", JSON.stringify(kvlProductArray));
        }

        const href = $(e.currentTarget).attr("href");
        if (href) {
            window.location.href = href;
        }
    });

};

const init = () => {
    initCache();
    if ($cache.pageTypeValue != CART) {
        cart();
    }
    initializeEvents();
    initCssLoader();
};

module.exports = {
    init: init,
    initializeEvents: initializeEvents
};
